import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import { loadFonts } from './plugins/webfontloader';

loadFonts();

const app = createApp(App);

import enums from '@/enums';
import sharedEnums from '@shared/enums';
app.config.globalProperties.$enums = { ...enums, ...sharedEnums };

app.use(store).use(router).use(vuetify).mount('#app');
